<div id="join-form" class="text-center ready-set-container">
	<h2 class="ready-set-header">Join the Movement</h2>
	<p class="mt-4 ready-set-content">
		Help us make Regulatory Operations (RegOps) a reality. Become
		<br class="d-none d-lg-block" />
		a RegScale partner today.
	</p>
	<form #f="ngForm" data-toggle="validator" novalidate="true" class="mt-5">
		<iframe src="https://go.regscale.com/l/999611/2022-11-05/2863i" width="100%" height="1000" type="text/html" frameborder="0" allowTransparency="true" style="border: 0" scrolling="no"></iframe>
	</form>
</div>
